import { useMemo } from 'react';

import { useBookmakersAll } from './useBookmakersAll';

export const useNonFavouritedExchanges = () => {
  const allBookmakers = useBookmakersAll();
  return useMemo(() => allBookmakers.filter(bookmaker => bookmaker.type.toLowerCase() === 'exchange'), [allBookmakers]);
};
